// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1v9LQ","signatureBlock":"Footer_signatureBlock__1jZJQ","signature":"Footer_signature__1o7xk"};